import { attr, BaseModel } from "../../lib/itn-ui-kit/data";

export default class CaseCallLogModel extends BaseModel {
  static urlPath = "call_logs";

  @attr("number") case;
  @attr("json") caller;
  @attr("json") receiver;
  @attr("string") voiceSystemDirection;
  @attr("string") startTime;
  @attr("string") endTime;
  @attr("number") duration;
  @attr("string") outcome;
  @attr("string") source;
}
